export const fmtMoney = (n: number) =>
  isNaN(n) ? '—' : n.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', maximumFractionDigits: 0 });

export const fmtMoney2 = (n: number) =>
  isNaN(n) ? '—' : n.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const fmtInt = (n: number) =>
  isNaN(n) ? '—' : Math.round(n).toLocaleString('pt-BR');

export const fmtPct = (n: number) =>
  isNaN(n) || !isFinite(n) ? '—' : `${(n * 100).toLocaleString('pt-BR', { maximumFractionDigits: 1 })}%`;

export const fmtDays = (n: number | null | undefined) =>
  n == null || !isFinite(n) ? '∞' : `${Math.round(n)}d`;

export const fmtDate = (s: string | null) => {
  if (!s) return '—';
  const isoDate = s.slice(0, 10);
  const match = isoDate.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (match) return `${match[3]}/${match[2]}/${match[1]}`;
  return new Date(s).toLocaleDateString('pt-BR');
};

export const fmtDateTime = (s: string | null) =>
  s ? new Date(s).toLocaleString('pt-BR') : '—';
